$(() => {
    var defaultDate = new Date();
    if (!$('.time-btn-cnt > label:not(.disabled)').length) {

        var tomorrow = defaultDate.setDate(defaultDate.getDate() + 1);
        var defaultDate = new Date(tomorrow);
    }
    $(".flatpickr-input").flatpickr({
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d H:i",
        inline: true,
        time_24hr: true,
        minDate: "today",
        defaultDate: defaultDate,
    });
    fetchCallBookingHours(new Date(defaultDate), true)

    $('.tb-next').on('click', function(){
        $('.form-morph .tab-pan').toggleClass('active')
        $('.tb-next, .submitbtn, .tb-prev').toggleClass('d-none');
        $('[data-book-a-call-form]').show()
    })

    $('.tb-prev').on('click', function(){
        $('.form-morph .tab-pan').toggleClass('active')
        $('.tb-next, .submitbtn, .tb-prev').toggleClass('d-none');
        $('[data-book-a-call-form]').hide()
    })

    $('.next-form').on('click', function(e){
        e.preventDefault();
        $('.second-part-form, button.main-form, .next-form, .prev-form, .form-first-step').toggleClass('d-none')

    })

    $('.prev-form').on('click', function(e){
        e.preventDefault();
        $('.second-part-form, button.main-form, .next-form, .prev-form, .form-first-step').toggleClass('d-none')
    })

    $(document).on('click', '.time-btn-cnt label', function (){
        if ($(this).hasClass('disabled')) {
            return;
        }
        $('.time-btn-cnt label').removeClass('active');
        $(this).toggleClass('active');
    });


    let modal_phone_input = document.querySelector('#modal_phone_number')

    let modal_iti = window.intlTelInput(modal_phone_input, {
        defaultCountry: 'ae',
        hiddenInput: "modal_phone_number",
        preferredCountries: ['ae', 'in', 'ru', 'de'],
        separateDialCode: true,
        customPlaceholder: function (
            selectedCountryPlaceholder,
            selectedCountryData
        ) {
            return "e.g. " + selectedCountryPlaceholder;
        },
    });

    let phone_input3 = document.querySelector('#phone_front')
    if (phone_input3) {
        let second_iti_front = window.intlTelInput(phone_input3, {
            defaultCountry: 'ae',
            hiddenInput: "phone_front",
            preferredCountries: ['ae', 'in', 'ru', 'de'],
            separateDialCode: true,
            customPlaceholder: function (
                selectedCountryPlaceholder,
                selectedCountryData
            ) {
                return "e.g. " + selectedCountryPlaceholder;
            },
        });
    }

    $(document).on('click', 'input[name="book-a-call-hour"]', (e) => {
        if ($(e.currentTarget).parent().hasClass('active')) {
            $('.tb-next.schedule').prop('disabled', false)
        }
    })

    $('[data-book-a-call-submit]').on('click', (e) => {
        var parent = $(e.currentTarget).closest('.input-cnt');
        let data = new FormData()
        let questionsContainer = parent.find('[data-book-a-call-questions-container]')

        let iti = $(e.currentTarget).data('iti')
        let question = questionsContainer.find('.selected[data-question-element]').text()
        let date = parent.find('[data-book-a-call-date]').val()
        let hour = parent.find('input[name="book-a-call-hour"]:checked').val()
        let number_prefix = eval(iti).getSelectedCountryData().dialCode;

        for (let [, {name, value}] of Object.entries(parent.find('form[data-book-a-call-form]').serializeArray())) {
            if (name === 'phone_number_main') {
                value = `+${number_prefix}${value}`
            }

            data.append(name, value)
        }

        data.append('question', question)
        data.append('date', date)
        data.append('hour', typeof hour === 'undefined' ? '' : hour)

        parent.find('[data-book-a-call-form]').hide()
        parent.find('[data-call-booking-buttons]').hide()
        parent.find(".send-suggestion-spinner").show()
        axios.post(storeCallBookingRoute, data)
            .then(({data}) => {
                let current_fs, next_fs
                let left, opacity, scale;

                current_fs = parent.find('fieldset#form-area').hide()
                next_fs = current_fs.next();

                next_fs.show();
                current_fs.animate({opacity: 0}, {
                    step: function (now) {
                        scale = 0.8 + (1 - now) * 0.2;
                        left = ((1 - now) * 50) + "%";
                        opacity = 1 - now;
                        current_fs.css({'left': left});
                        next_fs.css({'transform': 'scale(' + scale + ')', 'opacity': opacity});
                    },
                    duration: 400
                });
            })
            .catch(({response}) => {
                Swal.fire('Oops..', response.data.message, 'error')
                parent.find(".send-suggestion-spinner").hide()
                parent.find('[data-book-a-call-form]').show()
                parent.find('[data-call-booking-buttons]').show()
            })
    })

    $(".flatpickr-input").change((e) => {
        fetchCallBookingHours($(e.currentTarget).val())
        $('.tb-next.schedule').prop('disabled', true)
    });

    function fetchCallBookingHours(date, tomorrow_if_none_available) {
        axios.post(fetchCallBookingRoute, {date})
            .then(({data: {hoursView}}) => {
                $('[data-book-a-call-hours-container]').html(hoursView)
                $('[data-modal-book-a-call-hours-container]').html(hoursView)
            })
            .catch(({response}) => {
                console.log(response)
            })
    }

    $('[data-modal-book-a-call-submit]').on('click', ( e ) => {
        let data = new FormData()

        let date = $('[data-modal-book-a-call-date]').val()
        let hour = $('[data-modal-book-a-call-hours-container]').find('input[name="book-a-call-hour"]:checked').val()
        let number_prefix = modal_iti.getSelectedCountryData().dialCode;

        for (let [, {name, value}] of Object.entries($('form[data-modal-book-a-call-form]').serializeArray())) {
            if (name === 'modal_phone_number_main') {
                value = `+${number_prefix}${value}`
                data.append('phone_number_main', value)
            } else {
                data.append(name, value)
            }
        }

        data.append('date', date)
        data.append('hour', typeof hour === 'undefined' ? '' : hour)

        axios.post(storeCallBookingRoute, data)
            .then(( {data} ) => {
                Swal.fire('Success', data.message, 'success')
                $('#calendlyModal').data('bs.modal').hide();
            })
            .catch(( {response} ) => {
                Swal.fire('Oops..', response.data.message, 'error')
            })
    })
})